import moment from "moment";

// source as defined in WorkItemEditModel
export default function UpdateWorkItemModel(source) {
  return {
    workitemid: source.id,
    workitemcategoryid: source.workitemcategoryid,
    workitemcategoryname: source.workitemcategoryname,
    jobspecificaccessnotes: source.jobSpecificAccessNotes,
    preferredappointmentdate: moment(
      source.preferredAppointmentDate
    ).toISOString(),
    preferredappointmenttimeslot: source.preferredAppointmentSlot,
    preferredappointmenttimeslottitle: source.preferredAppointmentSlotTitle,
    workitemagreement: source.appointmentConfirmed,
    workitemagreementtitle: source.appointmentConfirmedTitle,
    workitemtemplateid: source.workitemtemplateid,
    reconnectelectricity: source.reconnectelectricity,
    reconnectheat: source.reconnectheat,
    reconnecthotwater: source.reconnecthotwater,
    disconnectelectricity: source.disconnectelectricity,
    disconnectheat: source.disconnectheat,
    disconnecthotwater: source.disconnecthotwater,
    propertyaccessnotes: source.propertyaccessnotes,
    redflag: source.redflag,
    successful: source.successful,
    workItemNotes: source.workItemNotes,
    expectedParts: source.expectedParts,
    faultyAssets: source.faultyAssets,
    createdBy: source.createdBy,
  };
}
